import TablaConciliacion from "../../../TablaConciliacion";

function TablaPisa() {
  return <TablaConciliacion nombreUseCase="pisa" titulo="PISA" />;
}

export default TablaPisa;
